import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'

/**
 * Slack OAuth Callback Page
 *
 * This page handles the OAuth callback from Slack.
 * It extracts the authorization code and state from the URL,
 * then posts them back to the opener window.
 */
export default function SlackCallbackPage() {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const error = searchParams.get('error')

    if (error) {
      // Handle OAuth error
      console.error('Slack OAuth error:', error)
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'slack-oauth-callback',
            error: error,
          },
          window.location.origin
        )
      }
      window.close()
      return
    }

    if (code && state) {
      // Send callback data to opener window
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'slack-oauth-callback',
            code,
            state,
          },
          window.location.origin
        )
      }
      // Close popup after a short delay
      setTimeout(() => {
        window.close()
      }, 500)
    }
  }, [searchParams])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-emerald-500 mx-auto mb-4" />
        <p className="text-gray-400">Processando autorizacao...</p>
        <p className="text-sm text-gray-500 mt-2">
          Esta janela sera fechada automaticamente.
        </p>
      </div>
    </div>
  )
}
